<template>
  <div>
    <el-dialog :title="title" width="1200px" class="dialog-wrap form-module" :visible.sync="showQuestions" :close-on-click-modal="false" :before-close="handleClose">
      <SchemeBaseInfo :PurchaseScheme="scheme"></SchemeBaseInfo>
      <div class="change_inform">
        <div class="title">历史问题</div>
        <el-table class="table_wrap1" :data="questions" style="width: 100%" border>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="fileList" label="问题附件">
            <template slot-scope="scope">
              <el-button v-if="scope.row.fileList.length > 0" v-for="(file, index) in scope.row.fileList" :key="index" type="text" @click.stop="download(file.fileId, file.fileName)">
                {{ file.fileName }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="提问时间"></el-table-column>
          <el-table-column prop="isRead" label="采购方查看状态"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SchemeBaseInfo from '@/views/Common/PurchaseScheme/SchemeBaseInfo.vue'
export default {
  components: {
    SchemeBaseInfo
  },
  props: {
    showQuestions: {
      type: Boolean,
      default: false
    },
    scheme: {
      type: Object
    },
    questions: {
      type: Array
    }
  },
  data() {
    return {
      title: '问题列表'
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:showQuestions', false)
    },
    download(fileId, fileName) {
      let token = window.localStorage.getItem('loginToken')
      var url = '/Common/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName=' + fileName
      this.downloadfile(this.baseURL + url)
    }
  },
  computed: {
    indexMethod(index) {
      console.log(index)
      return index + 1
    }
  }
}
</script>

<style scoped></style>